import * as types from "../types/groupedFoodIdsBasedOnCategory"
import { isArrayEqual } from "utils"

const initialState = {}

const groupedFoodIdsBasedOnCategoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.ADD_FOODS_TO_CATEGORY_GROUP: {
      const newState = { ...state }

      action.foods.forEach(food => {
        (food.categoryIds || []).forEach(foodCategoryId => {
          if (!newState[foodCategoryId]) {
            newState[foodCategoryId] = []
          }

          const set = new Set([...newState[foodCategoryId]])

          set.add(food._id)

          newState[foodCategoryId] = Array.from(set)
        })
      })

      return newState
    }
    case types.ADD_FOOD_TO_CATEGORY_GROUP: {
      const newState = { ...state }

      action.food.categoryIds.forEach(foodCategoryId => {
        if (newState[foodCategoryId]) {
          newState[foodCategoryId] = [action.food._id, ...newState[foodCategoryId]]
        } else {
          newState[foodCategoryId] = [action.food._id]
        }
      })

      return newState
    }
    case types.UPDATE_FOODS_IN_CATEGORY_GROUP: {
      const newState = { ...state }

      action.updatedFoods.forEach(updatedFood => {
        const oldFood = action.oldFoodsMap[updatedFood._id]

        if (!oldFood) {
          updatedFood.categoryIds.forEach(foodCategoryId => {
            if (newState[foodCategoryId]) {
              newState[foodCategoryId] = [updatedFood._id, ...newState[foodCategoryId]]
            } else {
              newState[foodCategoryId] = [updatedFood._id]
            }
          })

          return
        }

        // is old food categoryIds and updated categoryIds equal
        const equal =
          isArrayEqual(
            oldFood.categoryIds,
            updatedFood.categoryIds
          )

        if (equal) return

        oldFood.categoryIds.forEach(oldFoodCategoryId => {
          if (!newState[oldFoodCategoryId]) return

          const doesCategoryExist =
            updatedFood.categoryIds.includes(
              oldFoodCategoryId
            )

          if (doesCategoryExist) return

          newState[oldFoodCategoryId] =
            newState[oldFoodCategoryId].filter(foodId =>
              foodId !== oldFood._id
            )
        })

        updatedFood.categoryIds.forEach(updatedFoodCategoryId => {
          if (!newState[updatedFoodCategoryId])
            newState[updatedFoodCategoryId] = []

          const doesCategoryExist =
            oldFood.categoryIds.includes(
              updatedFoodCategoryId
            )

          if (doesCategoryExist) return


          newState[updatedFoodCategoryId] =
            [...newState[updatedFoodCategoryId], updatedFood._id]
        })
      })

      return newState
    }
    case types.REMOVE_FOODS_FROM_CATEGORY_GROUP: {
      const newState = { ...state }

      action.removedFoods.forEach(removedFood => {
        removedFood.categoryIds.forEach(categoryId => {
          if (!newState[categoryId]) return

          newState[categoryId] =
            newState[categoryId].filter(foodId =>
              foodId !== removedFood._id
            )
        })
      })

      return newState
    }
    case types.REPLACE_FOOD_IDS_IN_CATEGORY_GROUP: {
      const newState = { ...state }

      newState[action.categoryId] = action.foodIds

      return newState
    }
    case types.ADD_FOOD_CATEGORY_GROUP: {
      const newState = {
        ...state,
        [action.categoryId]: []
      }

      return newState
    }
    case types.UPDATE_FOOD_CATEGORY_GROUP: {
      const newState = { ...state }

      if (!newState[action.oldCategoryName]) return state

      newState[action.newCategoryName] = [...newState[action.oldCategoryName]]

      delete newState[action.oldCategoryName]

      return newState
    }
    case types.DELETE_FOOD_CATEGORY_GROUPED:
      const newState = { ...state }

      delete newState[action.categoryId]

      return newState
    case types.CLEAR_FOOD_CATEGORIES_GROUPS:
      return {}
    default:
      return state
  }
}

export default groupedFoodIdsBasedOnCategoryReducer